import React, {useEffect, useState, ChangeEvent, KeyboardEvent, Component} from 'react';
import ReactDOM from 'react-dom';
import ApexCharts from 'apexcharts'
import api from 'api';
import { Link, useNavigate } from 'react-router-dom';
import { API } from "common/config-api"; // jsconfig.json

const ProductEntityEmpty = () => {
  return (
    <tr><td colSpan="5">조회된 데이터가 없습니다.</td></tr>
  );
}

const ProductEntity = ({product}) => {
  // style="word-break:break-all"  //강제로 줄바꿈(특수문자 제외)
  // style="word-wrap:break-word"  //강제로 줄바꿈(특수문자 포함)
  if(product === null){ return (""); }
  return (
    <tr>
      <td style={{wordBreak: "break-all"}}>{product.name}</td>
      <td>{(product.price).toLocaleString('ko-KR')}</td>
      <td>{(product.salesPrice).toLocaleString('ko-KR')}</td>
      <td>{product.salesCnt}</td>
      {/*<td>{(product.price * product.salesCnt).toLocaleString('ko-KR')}</td>*/}
      <td>{(product.totalPrice).toLocaleString('ko-KR')}</td>
      {/*<td>-</td>*/}
    </tr>
  );
}

const ProductSummary = ({productPriceSum, adjustmentRate}) => {

  console.log("productPriceSum", productPriceSum);
  console.log("adjustmentRate", adjustmentRate);

  const afterTax = productPriceSum / 11 * 10;
  const fee = afterTax * (adjustmentRate/100);


  return (
    <>
  <tr rowSpan="2">
    <td colSpan="5">&nbsp;<br />&nbsp;</td>
  </tr>    
  <tr>
    <td>총 판매금액</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>{productPriceSum.toLocaleString('ko-KR')}</td>
  </tr>
  <tr>
    <td>세금 제외</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>{afterTax.toLocaleString('ko-KR')}</td>
  </tr>
  <tr>
    <td>정산 수수료({adjustmentRate}%)</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>{fee.toLocaleString('ko-KR')}</td>
  </tr>
  {/*<tr>
    <td>은행 송금 수수료</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
  </tr>*/}
  <tr>
    <td>합계</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>&nbsp;</td>
    <td>{(afterTax - fee).toLocaleString('ko-KR')}</td>
  </tr>
  </>
  );
}




const StatisticsManufactureProduct = () => {

    const thisYear = new Date().getYear() + 1900;
    const thisMonth = new Date().getMonth() + 1;
    const thisDate = new Date().getDate();

    const today = thisYear + "-" + thisMonth + "-" + thisDate;

    const firstday = thisYear + "-" + thisMonth + "-01";

    /*const [startDate, setStartDate] = useState(firstday); 
    const [endDate, setEndDate] = useState(today);
    const [manufacture, setManufacture] = useState("");
    const [adjustmentRate, setAdjustmentRate] = useState(20);*/

    const [forms, setForms] = useState({
        startDate: firstday,
        endDate: today,
        manufacture: "",
        adjustmentRate: 20
    });

    const onChange = (event) => {
      const { value, name } = event.target; //event.target에서 name과 value만 가져오기
      console.log('value: ' + value + ', name: ' + [name]);
      setForms({
        ...forms,
        [name]: value,
      });
    };


    const [productList, setProductList] = useState([]);

    const [productPriceSum, setProductPriceSum] = useState(0);

    let sum1 = 0;

    const getProductSalesList = async () => {
      const queryString = Object.entries(forms)
      .map((e) => e.join('='))
      .join('&');
      console.log("queryString: ", `${API.STATISTICS_MANUFACTURE_PRODUCT}?` + queryString);
      const resp = await (
        await api.get(`${API.STATISTICS_MANUFACTURE_PRODUCT}?` + queryString)
      ).data; // 2) 게시글 목록 데이터에 할당
      console.log("resp: ", resp);
      console.log("resp.length: ", resp.length);
      setProductList(resp);

      resp.forEach(function(i){
        if(i !== null){
          console.log("inForeach", i.price); 
          //sum1 += i.price * i.salesCnt;
          sum1 += i.totalPrice;
        }
      });
      console.log("sum1", sum1)

      setProductPriceSum(sum1);
    };

    const getManufactureProduct = () => {
      if(forms.manufacture === "" ){
        alert("딜러를입력 해 주세요");
        return false;
      }
      getProductSalesList();
    }

    


    

    useEffect(() => {
      //setProductPriceSum(sum1);
    }, []);

    return (
        <>
      <div className="row">

        <div>

          <div className="card">
            <div className="card-body">
              <h5 className="card-title">product sales - manufacture</h5>


              <div className="row">
                <div className="col-sm-2">
                  <input type="date" className="form-control" onChange={onChange} name="startDate" defaultValue={forms.startDate} />
                </div>
                <div className="col-sm-1">
                  ~
                </div>
                <div className="col-sm-2">
                  <input type="date" className="form-control" onChange={onChange} name="endDate" defaultValue={forms.endDate} />
                </div>
                <div className="col-sm-2">
                  <input type="text" className="form-control" onChange={onChange} name="manufacture" defaultValue={forms.manufacture} placeholder="딜러명or코드" />
                </div>
                <div className="col-sm-1">
                  <input type="number" className="form-control" onChange={onChange} name="adjustmentRate" defaultValue={forms.adjustmentRate} placeholder="20" />
                </div>                                
                <div className="col-sm-2">
                  <button type="button" onClick={getManufactureProduct} className="btn btn-primary">보기</button>
                </div>
                <div className="col-sm-2">
                  <button type="button" className="btn btn-primary">출력하기</button>
                </div>                
              </div>

              <div style={{marginTop: "20px"}}>&nbsp;</div>

              <table className="table table-hover">
                <thead>
                  <tr>
                    <th scope="col" width="50%">상품명</th>
                    <th scope="col">상품금액</th>
                    <th scope="col">판매금액</th>
                    <th scope="col">판매수량</th>
                    <th scope="col">판매금액</th>
                    {/*<th scope="col">비고</th>*/}
                  </tr>
                </thead>
                <tbody>
                  {productList.length === 0 || productList[0] === null ? <ProductEntityEmpty /> : null}
                  {productList.length > 0 ? productList.map((product, idx) => ( <ProductEntity key={idx} product={product} /> )) : ""}



                  {productList[0] !== null ? <ProductSummary productPriceSum={productPriceSum} adjustmentRate={forms.adjustmentRate} /> : "" }




                </tbody>
              </table>





            </div>
          </div>

        </div>


      </div>
      </>


    );

}

export default StatisticsManufactureProduct;